// CANONICAL COPY (GH #7115). src/constants/obligations/obl-cde-scoping.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-cde-scoping',
  title: 'Review and confirm cardholder data environment (CDE) scope',
  description:
    'Formally define and document the cardholder data environment (CDE), identifying all system components that store, process, or transmit cardholder data or sensitive authentication data, as well as any system components that could impact the security of the CDE (e.g. shared services, connected-to systems). The scope shall be reviewed and confirmed at least annually and upon any significant change (new store/process/transmit flow, new connected system, infrastructure change, acquisition). Maintain a current data-flow diagram, network diagram and scope statement.',
  category: 'compliance',
  scfIds: ['SCF-OPS-012'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'CDE scope statement / data-flow diagram is published',
    },
    { type: 'document-approved', description: 'Scope statement has been approved' },
    { type: 'document-within-sla', description: 'Scope review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
